// Internal modules
import {
  blurHandler,
  changeHandler as genericChangeHandler,
} from '../../../Form/handlers';
import { logBlurOrFocusEvent as focusHandler } from '../../../Form/utils';
import { updateIdentityDocumentNumber } from './utils';

const changeHandler = (e, value, ...rest) => {
  genericChangeHandler(e, value, ...rest);

  // if IdentityDocumentType is updated to a new type, we need to update
  // IdentityDocumentNumber correspondingly with the new mask and re-validate
  updateIdentityDocumentNumber(value);
};

export { blurHandler, changeHandler, focusHandler };
